'use strict';

//This file contains methods for:
//	1. add
//	2. report
//	3. moderate
//  4. show more reviews
//  5. hide broken avatar images

//show more reviews
function enableMore() {

	var $moreReviewsWrapper = $('.js-showmore-reviews');
	var $moreReviewsLink = $('.js-showmore-link');
	var $reviewsList = $('.js-reviews-list ul');
	var $commonError = $('.js-review-error');
	var originalText = $moreReviewsLink.text();

    var success = function (response) {
        $moreReviewsWrapper.remove();
        $reviewsList.append(response);
        //only call applyRating in service-site-assets, calling TES:applyRating updates count at top
        $('body').trigger('TES:applyRatingStars');
        enableMore();
    };

    $moreReviewsWrapper.on('click', function(e) {
		e.preventDefault();
		var moreReviewEndpoint = $(this).data().more;
		if(moreReviewEndpoint) {
			$.ajax({
				type: 'GET',
				dataType: 'html',
				contentType: 'text/html; charset=utf-8',
				url: moreReviewEndpoint,
				beforeSend: function() {
					$moreReviewsLink.text('Loading more reviews ...');
				},
				success: success,
				error: function(){
					$moreReviewsLink.prop('hidden', false);
					$moreReviewsLink.text(originalText);
					$commonError.show();
				}
			});
		}
	});
}


$(function(){

	// Enable more reviews
	enableMore();

	//Add a review
	var $addReviewContainer = $('.js-add-resource-review');
	var $loginBtn = $('.js-add-resource-login');

	//Check if add review form exists, only than do stuff
	if($addReviewContainer.length === 0) return;

	window.TES = window.TES || {};

	var resourceAuthor = window.TES.resource && window.TES.resource.authorId.toString();
	var user = window.TES.user;
	var userId = user.getId() && user.getId().toString();
	var currentUserIsAuthor = function() {
		return user.isAuthenticated() && userId === resourceAuthor;
	};

	//Check if user is not logged in than show the login button and return
	if(!user.isAuthenticated()) {
		$loginBtn.show();
		return;
	}
	//Check if user is not author and logged in than show the form, else return
	if(!currentUserIsAuthor()) {
		$addReviewContainer.show();
	}
	else {
		return;
	}

	var $addReviewBtn = $('.js-review-addBtn');
	var $reviewsListContainer = $('.js-reviews-list');
	var $rating = $('.js-review-rating');
	var $comment = $('.js-review-comment');
	var $ratingError = $('.js-rating-error');
	var $commentError = $('.js-comment-error');
	var $commonError = $('.js-review-error');
	var $commonSuccess = $('.js-review-success');
	var $noReviewsMessage = $('.js-no-reviews');

	var isValidRating = function() {
		return $rating.val() !== '0';
	};
	var isValidComment = function() {
		return $comment.data('notrequired') === true || $comment.val().trim().length !== 0;
	};
	var isAnyError = function() {
		return !isValidRating() || !isValidComment();
	};
	var hideCommonMessages = function() {
		$commonError.add($commonSuccess).slideUp();
	};
	var resetForm = function() {
		$rating.val(0);
		$comment.val('');
		$addReviewBtn.prop('disabled', false);
	};
	var success = function(response) {

		//hide the no reviews message - if there was a written (not just rated)
		if($comment.val().trim().length !== 0) {
			$noReviewsMessage.slideUp();
		}

		//Replace the current list with the new list
		$reviewsListContainer.replaceWith(response);

		//update the refrence
		$reviewsListContainer = $('.js-reviews-list');
		$commonSuccess.show();

		// Update comments count 
	    var resourceId = $('.js-favourites').data().resourceid;
		$.get('/api/review/resource/'+resourceId+'/rating', function(data) {
			var rating = data.ratings;
            function pluralise (count) { return count === 1 ? ' Review' : ' Reviews'; }
			$('.review-title-text').text(pluralise(rating));
			$('.total-reviews-count').text(rating);
			if(rating > 5) { enableMore(); }
		});

		//Rating
		$('body').trigger('TES:applyRating');

		//hide message after sometime and reset the form
		setTimeout(function(){
			hideCommonMessages();
			resetForm();
		}, 1000);
	};

	//Toggle rating error when user select valid option
	$rating.on('change', function(){
		$ratingError.toggle( !isValidRating() );
		hideCommonMessages();
	});

	//Toggle comment error when user types
	$comment.on('keyup', function(){
		$commentError.toggle( !isValidComment() );
		hideCommonMessages();
	});

	//Click event
	$addReviewBtn.on('click',function(e){

		e.preventDefault();

		if(isAnyError()) {
			$rating.change();
			$comment.keyup();
			return;
		}
		else {

			//Hide common error or success messages
			hideCommonMessages();

			var data = {
				rating: $rating.val(),
				comment: $comment.val(),
				asset: {
					id: $('.js-resource-id').val(),
					type: 'resources',
					authorId: $('.js-author-id').val()
				},
				template: $('.js-reviews-list-template').val()
			};

			//Ajax to add review
			$.ajax({
				type: 'POST',
				dataType: 'html',
				contentType: 'application/json; charset=utf-8',
				url: '/api/review',
				data: JSON.stringify(data),
				beforeSend: function() {
					$addReviewBtn.prop('disabled', true);
				},
				success: success,
				error: function(){ $commonError.show(); }
			});
		}
	});
});


$(function(){
	//Report a review
	var $reviewsList = $('.js-reviews-wrapper');
	var reviewIdToReport = null;
	var ajaxUrl;

	//Get the report id
	$reviewsList.delegate('.js-report-review', "click", function(e) {
		e.preventDefault();
		var $this = $(this);
		reviewIdToReport = $this.data().reviewid || null;
		//Update ajaxUrl var
		ajaxUrl = $reportForm.attr('action').replace('##reviewid##', reviewIdToReport);
	});

	//On submit report
	var $reportForm = $('.js-report-review-form');
	var $reporterName = $reportForm.find('#reportername');
	var $reporterEmail = $reportForm.find('#reporteremail');
	var $reporterComment = $reportForm.find('#reportercomment');
	var ajaxMethod = $reportForm.attr('method');
	var errors = false;
	var onSuccessReport = function(){
		$reportForm.addClass('ResourceReviewsReport-successed');
		$reporterComment.val('');
		reviewIdToReport = null;
	};
	var onErrorReport = function(){
		$reportForm.addClass('ResourceReviewsReport-failed');
	};

	//On hide, remove unwanted css classes
	$('#report-review-modal').on('hidden.bs.modal', function(e){
		$reportForm
			.removeClass('ResourceReviewsReport-successed ResourceReviewsReport-failed')
			.get(0).reset();
	});

	//On form submit, send data using ajax
	$reportForm.submit(function(e){
		e.preventDefault();
		//console.log(reviewIdToReport);
		if(!reviewIdToReport) return;

		//Validation
		if($reporterName.val().trim().length === 0) {
			$reporterName.closest('.form-group').addClass('has-error');
			errors = true;
		}
		if($reporterEmail.val().trim().length === 0) {
			$reporterEmail.closest('.form-group').addClass('has-error');
			errors = true;
		}
		if($reporterComment.val().trim().length === 0) {
			$reporterComment.closest('.form-group').addClass('has-error');
			errors = true;
		}

		if(errors) return;
		else {
			//Remove error class
			$reportForm.find('.modal-body .has-error').removeClass('has-error');
		}

		var complaint = {
            name: $reporterName.val(),
            email: $reporterEmail.val(),
            message: $reporterComment.val(),
            reviewContent: $('#comment-'+reviewIdToReport).text(),
            title: document.title,
            url: window.location.href
        };

        $.ajax({
            type: ajaxMethod,
            url: ajaxUrl,
            data: JSON.stringify(complaint),
            statusCode: {
		        401: onErrorReport,
		        404: onErrorReport,
		        406: onErrorReport,
		        200: onSuccessReport,
		        201: onSuccessReport,
		        202: onSuccessReport
		    },
            contentType: "application/json; charset=utf-8",
            dataType: 'json'
        });

	});
});


//Moderate a review
$(function(){
	var $reviewsList = $('.js-reviews-wrapper');
	$reviewsList.delegate('.js-review-moderate', "click", function(e) {
		e.preventDefault();
		var $this = $(this);
		var reviewIdToModerate = $this.data().reviewid || null;
		if(!reviewIdToModerate) return;
		$.ajax({
			dataType: 'html',
	        type: 'POST',
	        url: '/api/review/' + reviewIdToModerate + '/moderate',
	        error: function() {
	        	window.alert('Cannot moderate the review. Please try again.');
	        },
	        success: function() {
	        	$this.replaceWith('<span>moderated</span>');
	       	}
	    });
	});
});


$(function(){
	//hide avatar images which are broken
	$('.UserProfile-avatar img').error(function(){
		$(this).hide();
	});
});
